import { createFileRoute, redirect, Outlet } from '@tanstack/react-router'
import toast from 'react-hot-toast'
import { useAuthStore } from '@/stores/auth'
import { AuthenticatedLayout } from '@/components/layout/AuthenticatedLayout'
import { UserGroupEnum, isRoleAllowed, findRouteAccess, ANALYTICS_ROLE_LABELS } from '@/lib/permissions'
import { isPostHogEnabled, posthog } from '@/lib/posthog'
import { moduleFromPathname } from '@/lib/analytics-modules'

const FALLBACK_ROUTE = '/painel'

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ location }) => {
    const state = useAuthStore.getState()

    if (!state.isAuthenticated()) {
      throw redirect({ to: '/' })
    }

    const raw = Number(state.user?.jobTitle)
    const validValues = Object.values(UserGroupEnum) as number[]
    const role = validValues.includes(raw)
      ? (raw as UserGroupEnum)
      : null

    if (role == null) return

    if (findRouteAccess(location.pathname) && !isRoleAllowed(role, location.pathname)) {
      toast.error('Você não tem permissão para acessar esta página')
      if (isPostHogEnabled) {
        posthog.capture('bo_permission_denied', {
          module: moduleFromPathname(location.pathname),
          action_attempted: location.pathname,
          user_role: ANALYTICS_ROLE_LABELS[role],
        })
      }
      if (location.pathname !== FALLBACK_ROUTE) {
        throw redirect({ to: FALLBACK_ROUTE })
      }
    }
  },
  component: () => (
    <AuthenticatedLayout>
      <Outlet />
    </AuthenticatedLayout>
  ),
})
